export enum PatientStationViewByType {
    Unit = 1,
    Specialty = 2
}